export default __webpack_public_path__ + "static/2-5e0d22e446ea01f5ed8120d26658dc9f.jpeg";